import React from "react";
import Svg, { G, Path } from "react-native-svg";

type Avatar36Colors = {
  background?: string;
  skin?: string;
  hair?: string;
};

export const Avatar36 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar36Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    hair: colors.hair ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar36">
        <G id="Group">
          <Path
            id="background"
            d="M151.833 303.667c83.856 0 151.834-67.978 151.834-151.834C303.667 67.978 235.689 0 151.833 0 67.978 0 0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
            fill={c.background}
          />
          <Path
            id="skin"
            d="M216.987 139.736c0-48.596.159-91.984-41.516-91.984-75.244 0-81.488 30.55-81.488 79.138 0 1.139.032 2.286.088 3.433a12.64 12.64 0 0 0-2.47.589c-6.123 2.063-7.23 13.849-2.476 26.329 4.635 12.169 13.133 20.491 19.233 18.986.382.661.765 1.322 1.155 1.975.43 4.245 2.174 22.578 1.195 30.279-1.115 8.729-7.391 21.192-7.391 21.192s44.312 37.63 75.992 34.827c13.276.04 11.93-12.376 11.93-12.376s-1.72-10.266-.493-16.446c.716-3.576 15.768-31.625 25.365-66.388 2.086-13.554.876-13.507.876-29.554Z"
            fill={c.skin}
          />
          <Path
            id="Vector"
            d="M129.271 131.294s11.826-2.118 21.869-2.118c7.127 0 16.055 1.649 19.376 1.983.82.08 1.625-.247 2.126-.86l1.856-2.254c1.012-1.234.406-3.042-1.179-3.504-5.025-1.473-14.836-4.81-21.59-4.293-9.668.741-16.549 1.091-22.466 11.046h.008Z"
            fill="#000"
          />
          <Path
            id="Vector_2"
            d="M194.966 170.684c.095-4.961-4.412-13.785-4.532-25.293-.087-8.848 4.747-19.409 2.079-20.237-2.668-.828-5.352 9.039-5.503 20.356-.096 7.096 5.535 25.166 2.915 26.433-2.62 1.274-18.995-1.991-19.679.724-.685 2.716 2.747 3.25 13.929 4.054 8.688-.351 10.695-1.067 10.799-6.029l-.008-.008Z"
            fill="#2E2017"
            fillOpacity={0.75}
          />
          <Path
            id="Vector_3"
            d="M190.061 128.38c-.104.868.693 1.592 1.585 1.449 3.599-.581 10.074-1.585 13.969-1.473 4.603.127 11.276.868 11.276.868s.869-6.682-.732-7.781c-1.601-1.099-7.208-1.163-11.548-1.163s-7.072.908-9.413 1.872c-3.64 1.513-4.89 4.149-5.137 6.228Z"
            fill="#000"
          />
          <Path
            id="Vector_4"
            d="M172.015 138.247c-10.521-10.704-30.152-1.386-33.768 2.166-.502.494-.557 1.37-.119 1.967.263.359.637.526 1.003.502.247-.016.486-.12.685-.319 1.091-1.075 3.95-2.787 7.606-4.197 0 .255 0 .51.032.773.374 3.177 3.416 5.431 6.793 5.033 3.377-.398 5.813-3.297 5.439-6.475a5.41 5.41 0 0 0-.494-1.68c4.15.04 8.195 1.187 11.269 4.316.502.51 1.259.462 1.689-.111.43-.573.366-1.457-.135-1.967v-.008Z"
            fill="#000"
          />
          <Path
            id="Vector_5"
            d="M216.318 136.964c-3.202-2.962-18.907-9.19-24.712 3.043-.279.581-.175 1.465.231 1.975.406.501.955.438 1.234-.144a11.66 11.66 0 0 1 2.055-3.034c.454 3.409 3.735 5.814 7.374 5.392 3.68-.43 6.332-3.584 5.918-7.048a6.16 6.16 0 0 0-.239-1.099c3.392.796 6.26 2.277 7.359 3.289.175.167.366.231.549.207.271-.032.51-.263.637-.653.215-.653.024-1.521-.414-1.928h.008Z"
            fill="#000"
          />
          <Path
            id="Vector_6"
            d="M191.232 252.116s1.337 12.415-11.931 12.376c-31.68 2.803-75.992-34.827-75.992-34.827L46.184 260.86c27.332 26.488 64.579 42.798 105.65 42.798 32.588 0 62.78-10.273 87.516-27.754l-48.118-23.796v.008Z"
            fill="#000"
          />
          <Path
            id="Vector_7"
            d="M190.626 233.95a42.658 42.658 0 0 1-5.025 1.035c-20.101 2.883-35.838-7.948-41.811-12.878 0 0-7.574-6.864-15.132-14.996 9.27 16.733 26.704 41.031 57.875 53.311.708.279 1.385.454 2.054.566 3.21-3.656 2.652-8.864 2.652-8.864s-1.601-11.954-.613-18.174Z"
            fill="#2E2017"
            fillOpacity={0.75}
          />
          <Path
            id="hair"
            d="M226.001 79.297c-.533-8.689-10.345-15.115-13.315-17.401-2.971-2.286-4.771-13.173-7.709-17.465-2.939-4.285-11.835 1.043-16.04-2.015-4.205-3.058-6.212-7.582-14.184-8.936-7.972-1.353-8.195 3.76-12.941 3.696-4.747-.064-9.533-6.778-20.547-5.177-11.014 1.6-16.406 11.46-21.702 15.14-5.296 3.679-16.645 1.242-20.898 5.264-9.381 8.864-8.011 16.127-8.067 19.878-.048 3.75-9.788 4.834-10.64 9.477-1.96 10.576 3.504 7.924 5.312 18.253 1.195 6.834-4.73 7.638-3.425 14.471 1.306 6.833 3.29 5.224 5.265 9.023.947 1.824 1.975 6.172 3.018 8.171.454-.318.932-.613 1.481-.756 6.985-1.832 11.269-.988 14.861 5.503.175 1.585 7.024 48.707 7.59 50.523 3.592 11.476 29.729 35.169 29.729 35.169 5.973 4.93 21.71 15.753 41.811 12.878 25.804-3.695 21.877-24.258 21.551-26.863-.319-2.604 3.329-21.821 3.329-21.821s-2.939-8.41-15.092-10.664c-1.139.51-5.097 1.609-6.244 1.768-.271.04-5.033-.541-5.503-.517-3.154.151-8.203-1.067-11.803-1.203-9.469 1.657-32.692 17.394-33.464 21.479-3.035-1.625-3.456-3.186-10.974-8.681-4.205-3.074-6.81-7.98-8.347-13.642-1.624-5.973-2.062-12.774-1.935-19.145.199-9.788-.231-25.772-.414-31.737 3.464-7.088 7.231-7.98 7.502-11.165.526-6.133-2.453-23.948 10.624-31.418 5.774 15.219 15.378 12.623 15.378 12.623s-2.405-1.944-2.731-8.442c-.175-3.528 3.058-6.1 6.06-7.725 8.474.804 15.665 4.125 22.315 3.902 10.489-.35 4.691-6.41 14.391-5.838 22.881 1.362 26.871 30.359 26.871 30.359s3.838-5.184 6.013-8.434c2.174-3.249 3.408-9.827 2.866-18.516l.008-.016Zm-38.975 110.604c12.535-.605 15.936-7.271 16.023-5.487.04.796 1.744 21.192-6.267 25.246-6.945 3.512-3.305-1.641-3.305-5.392-1.553 1.107-3.974 2.118-7.725 2.294-3.743.183-6.101-.59-7.59-1.585.024.533-2.907 9.222-8.37 9.66-5.463.438-16.518-9.939-16.876-15.896-.334-5.543 6.459-14.646 9.891-13.778 7.351 1.848 15.538 5.352 24.219 4.938Z"
            fill={c.hair}
          />
          <Path
            id="Vector_8"
            d="M204.021 189.177s-8.688 2.349-18.564 2.54c-10.926.207-23.135-1.704-23.039-.454.175 2.374 17.457 8.538 23.238 8.108 7.582-.558 18.764-9.215 18.357-10.194h.008Z"
            fill="#2E2017"
            fillOpacity={0.75}
          />
        </G>
      </G>
    </Svg>
  );
};
